const styles = theme => {
    return {
        paperRoot: {
            marginTop: '4px',
            marginLeft: '0.5rem',
            marginRight: '0.5rem',
            overflowY: 'visible',
            overflowX: 'hidden',
            height: 'auto',
            marginBottom: 0,
            position: 'relative',
            fontSize: '0.8125rem',
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 16px rgba(15, 23, 42, 0.05)',
        },
        assignPageRoot: {
            position: 'relative',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            /* action bar */
            paddingBottom: '4.5rem',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
        },
        assignPageBody: {
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            padding: '4px 6px 8px',
        },
        root: {
            display: "block",
            width: '100%',
            minWidth: 0,
        },
        boxHolder: {
            padding: "4px 8px 8px",
            background: '#f8fafc',
            borderRadius: '10px',
            border: '1px solid #e2e8f0',
            minHeight: 0,
            height: 'fit-content',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
        textField: {
            marginLeft: '0px',
            marginRight: '0px',
            '& .MuiInputLabel-root': {
                fontSize: '0.83rem',
                fontWeight: 500,
                color: '#000000',
            },
            '& .MuiInputBase-input': {
                fontSize: '0.8125rem',
                paddingTop: '4px',
                paddingBottom: '4px',
            },
            '& .MuiInput-root': {
                fontSize: '0.8125rem',
            },
            '&.MuiFormControl-marginNormal, &.MuiTextField-root': {
                marginTop: '4px',
                marginBottom: '4px',
            },
        },
        searchtextField: {
            marginLeft: '0px',
            marginRight: '0px',
            width:'50%',
            '& .MuiInputLabel-root': { fontSize: '0.83rem' },
            '& .MuiInputBase-input': { fontSize: '0.8125rem' },
        },
        scantextField: {
            marginLeft: '0px',
            marginRight: '0px',
            width: '100%',
            '& .MuiInputLabel-root': { fontSize: '0.83rem' },
            '& .MuiInputBase-input': { fontSize: '0.8125rem' },
        },
        tablebody:{
            color: '#0f172a',
            fontSize: '0.7rem',
            fontWeight:' 400',
            padding: '4px 12px'
        },
        tableHeadCell:{
            color: '#0369a1',
            fontSize: '0.65rem',
            fontWeight: '600',
            padding: '4px 6px',
            whiteSpace: 'normal',
            lineHeight: 1.2,
            wordBreak: 'normal',
            overflowWrap: 'normal',
            hyphens: 'none',
            verticalAlign: 'bottom',
        },
        TableHeadTop: {
            border: '1px solid #e2e8f0',
            fontSize:'0.8rem !important',
            fontWeight:'600 !important',
            textAlign:'center',
            flex: '1 1 0',
            minWidth: 0,
            borderRadius: '6px',
            height: 'auto',
            padding: '8px 10px',
            background: '#f1f5f9',
            color: '#0f172a',
            boxSizing: 'border-box',
        },
        TableHead: {
            border: '1px solid #e2e8f0',
            fontSize:'0.8rem !important',
            fontWeight:'600 !important'
        },
        table:{
            border: '1px solid #e2e8f0',
            padding:0,
            height: 'auto',
            borderRadius: '8px',
            overflow: 'hidden',
            width: '100%',
            maxWidth: '100%',
        },
        layoutBorder:{
            border:'none',
            padding:'2px 4px',
            paddingRight: '0px !important',
            verticalAlign: 'top',
        },
        cursorIcon:{
            cursor:'pointer'
        },
        adjustDrugGrid:{
            margin: '8px 0 0 0',
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
        },
        commonFontSize:{
            fontSize:'0.8125rem'
        },
        removeIcon:{
            border:'none',
            width:'30px',
            padding:'0'
        },
        iconButton: {
            padding: 6,
        },
        trHeight:{
            height:'18px'
        },
        buttonContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        assignForm: {
            alignItems:'flex-start',
            position: 'relative',
            padding: "8px 12px",
            background: '#ffffff',
            borderRadius: '10px',
            border: '1px solid #e2e8f0',
            minWidth: 0,
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden',
            '& .MuiFormControl-root': {
                marginTop: '4px',
                marginBottom: '4px',
            },
            '& .MuiInputLabel-root': {
                fontSize: '0.83rem',
                color: '#000000',
            },
            '& .MuiInputBase-input, & .MuiInputBase-root': {
                fontSize: '0.8125rem',
            },
            '& .MuiTableCell-root': {
                paddingTop: '2px',
                paddingBottom: '2px',
            },
            '& .MuiAccordionSummary-root': {
                minHeight: '34px',
                '&.Mui-expanded': { minHeight: '34px' },
            },
            '& .MuiAccordionSummary-content': {
                margin: '4px 0',
                '&.Mui-expanded': { margin: '4px 0' },
            },
            '& .MuiTypography-root': {
                fontSize: '0.8125rem',
            },
        },
        paper: {
            padding: '0px',
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
        box: {
            display: "grid",
            gridTemplateColumns: "1fr 1.5fr 1fr 1fr 1fr 1fr",
            gridTemplateRows: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
            gridColumnGap: "4px",
            gridRowGap: "4px",
            justifyItems: "stretch",
            alignItems: "stretch",
            height: "100%"
        },
        displayBin: {
            gridRow: "4 / span 5",
            gridColumn: "3 / span 2",
            width: "100%",
            height: "100%",
            borderRadius: "5px",
            boxShadow:"0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)"
        },
        columnTitle: {
            textAlign: "center",
            marginTop: "auto",
            marginBottom: "auto"
        },
        rowTitle: {
            textAlign: "center",
            marginTop: "auto",
            marginBottom: "auto"
        },
        patientInfo: {
            paddingTop: "8px"
        },
        patientNameText: {
            fontSize: "1.25em"
        },
        patientDoBText: {},
        rxInput: {
            gridColumn: "1 / span 3"
        },
        rxInfo: {
            paddingTop: "8px"
        },
        rxItems: {
            gridColumn: "1 / span 3",
        },
        cancel: {},
        save: {},
        accountBoxSelectionContainer: {
            display: "grid",
            gridTemplateColumns: "50% 50%",
            paddingLeft: "80px",
            paddingRight: "80px",
            paddingTop: "20px",
            gridGap: "40px"
        },
        boxSide: {
            display: "grid",
            gridTemplateRows: "40px auto"
        },
        boxDesign: {
            height:'369px',
            width:'180px',
            boxShadow: 'none',
        },
        boxLogo: {
            float:'left',
            height:'40px',
            width:'40%',
            border:'1px solid #888',
            borderRadius:'5px',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
        },
        stockCode: {
            textAlign: 'center',
            lineHeight: '20px'
        },
        spacer: {
            width:'5%'
        },
        boxcontainer: {
            width: '100%',
            float:'left',
            display:'flex',
            alignItems:'center'
        },
        boxLogoDesc: {
            float:'left',
            color:'#000',
            fontSize:'10px',
            display:'inline-flex',
            width:'65%',
        },
        deliveryContainer: {
            width:'100%',
            borderBottom:'1px solid #000',
            float:'left',
            fontSize:'10px',
            padding:'5px 0px',
        },
        prescriptionContainer:{
            width:'100%',
            marginTop:'5px',
            float:'left',
            fontSize:'10px',
            padding:'5px 0px',
            lineHeight:'15px'
        },
        qrcodeContainer:{
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            float:'left',
         },
        img: {
            height:'70px',
            width:'70px'
        },
        dialogBackground: {
            background: '#fb923c'
          },
          dialogContentColor: {
            color: '#387371',
            textAlign: 'center',
            fontSize: '1.25em'
          },
          dialogTitleColor: {
            color: '#387371',
            textAlign: 'left',
            fontSize: '1.1em'
          },
          alignButton: {
            justifyContent: 'center',
            alignItems: 'center'
          },
          buttonColor: {
            color: '#387371',
            fontSize: '1.25em'
          },
          messageInfo: {
            textAlign: 'center'
          },
          handleOverflow:{
            height:'auto',
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
            maxHeight:'220px',
            minHeight:'120px',
            overflowX:'auto',
            overflowY:'auto',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            background: '#fff',
          },
          handleStcPic:{
            borderRadius: '8px',
            border: '1px solid #e2e8f0'
          },
          boxType: {
            marginRight: "20px",
            width: 500,
            marginLeft: '0px',
          },
          th: {
            padding:'2px 0px'
          },
          selectLable: {
            marginBottom: '-18px',
            color: 'red',
          },
          emptyRowCell : {
            textAlign: 'center',
            fontSize: '0.75rem',
            padding: '8px 0 !important',
          },
          pauseButton: {
            fontSize: '18px !important',
            fontFamily: 'Material Icons',
            fontWeight: 'normal',
            fontStyle: 'normal',
            lineHeight: '1',
            letterSpacing: 'normal',
            textTransform: 'none',
            display: 'inline-block',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            direction: 'ltr',
          },
          tableCell:{
            padding:'0px !important'
          },
          spinner:{
            position: 'fixed',
            background: 'rgba(255,255,255,.72)',
            width: '100%',
            height: '100%',
            zIndex: 11000,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'auto',
            cursor: 'wait',
          },
          spinnerImage:{
            top: 'calc(50% - 32.5px)',
            left: 'calc(50% - 65px)',
            position: 'absolute',
            width: '130px',
            userSelect:'none',
            zIndex: 99999,
          },
          hidden :{
              display:'none'
           },
        tableCart:{
            border: '1px solid #e2e8f0',
            padding:0,
            borderRadius: '8px',
            overflow: 'hidden',
        },
        textArea:{
            resize: 'none',
            borderRadius: '6px',
            padding: '6px 8px',
            width: '100%',
            fontSize: '0.8125rem',
            border: '1px solid #e2e8f0',
            background: '#ffffff',
            color: '#0f172a',
            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05), 0 1px 3px rgba(15, 23, 42, 0.08)',
            '&:focus': {
              outline: 'none',
              borderColor: '#0369a1',
              background: '#ffffff',
              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05), 0 1px 3px rgba(15, 23, 42, 0.08), 0 0 0 3px rgba(3, 105, 161, 0.12)',
            },
        },
        padiGridCell: {
            color: 'rgba(0, 0, 0, 0.54)',
            fontSize: '0.8125rem',
            fontWeight: 500,
            textAlign: 'right',
            borderBottom: 'none',
            padding: '2px 12px 2px 8px !important'
        },
        main:{
            display: 'block',
            width: '100%',
            boxSizing: 'border-box',
        },
        codetable:{
            fontSize:'1.1rem',
            marginLeft:'40px',
            marginTop:'-20px',
            lineHeight:'1.4em',
            textAlign:'center'
        },
        stock:{
            marginLeft:'10px',
            color:'#0369a1',
            fontWeight:500,
        },
        pickuptitle:{
            marginLeft:'20px'
        },
        searchArea:{
            display:'flex',
            justifyContent:'flex-end',
            marginTop:'-48px',
            marginBottom:'8px'
        },
        locationType:{
            paddingTop: '4px',
            paddingBottom: '4px',
            fontSize: '0.8125rem',
        },
        tableCellLabel: {
            color: 'rgba(0, 0, 0, 0.54)',
            fontSize: '0.7rem',
            padding: 0,
            fontWight: '500',
            lineHeight : '1rem'
        },
        // Keep two-column layout on landscape tablets; densify instead of hiding bins
        '@media only screen and (min-width: 1024px) and (max-width:1440px) and (orientation:landscape)':{
            assignForm: {
                alignItems:'flex-start',
                padding: "4px 6px",
                width: '100%',
            },
            boxHolder: {
                padding: "2px"
            },
            adjustDrugGrid:{
                margin: '8px 0 0 0'
            },
            locationType:{
                paddingTop: '4px',
                paddingBottom: '4px'
            },
            handleOverflow:{
                minHeight: '110px',
                maxHeight: '200px',
            },
        },
        '@media print':
        {
            body :
            {
                width:'192px',
                height:'384px'
            }
        },
      basicNotifyBar: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '2px 14px',
        margin: '4px 0 8px',
        padding: '6px 12px',
        border: '1px solid #d7e8f2',
        borderRadius: '10px',
        background: 'linear-gradient(135deg, #f4faff 0%, #ffffff 100%)',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      },
      basicNotifyLabel: {
        color: '#0f172a',
        fontSize: '0.8125rem',
        fontWeight: 700,
      },
      basicNotifyHelp: {
        color: '#64748b',
        fontSize: '0.75rem',
      },
      basicRxCard: {
        marginTop: '8px',
        border: '1px solid #d7e8f2',
        borderRadius: '10px',
        background: '#ffffff',
        overflow: 'visible',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      },
      basicRxHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 12px',
        background: '#e8f6fc',
        color: '#0c4a6e',
        fontSize: '0.8125rem',
        fontWeight: 700,
      },
      basicRxRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '4px 12px 8px',
      },
      primaryButton: {
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.75rem',
        borderRadius: '8px',
        background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
        color: '#fff',
        boxShadow: '0 2px 8px rgba(3, 105, 161, 0.28)',
        '&:hover': {
          background: 'linear-gradient(135deg, #0369a1 0%, #075985 100%)',
          boxShadow: '0 4px 12px rgba(3, 105, 161, 0.35)',
        },
        '&:disabled': {
          background: '#e2e8f0',
          color: '#94a3b8',
          boxShadow: 'none',
          cursor: 'not-allowed',
        },
     },
     onAmoutDueEditPrimaryButton: {
       background: 'none',
       color: 'rgba(0, 0, 0, 0.54)',
      '&:hover': {
          background: '#0284c7',
          color: '#fff',
        },
    },
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/index.styles.js